import { createFileRoute } from '@tanstack/react-router';
import {
  creditProductListScreen,
  creditProductListSearch,
  loadCreditProductMessages,
  loadCreditProductScreens,
} from '@/modules/credit-product/route';
import { lazyScreen } from '@/shared/screen';
export const Route = createFileRoute('/_app/cadastro/produtos-credito/')({
  validateSearch: creditProductListSearch,
  staticData: { screen: creditProductListScreen },
  loader: loadCreditProductMessages,
  component: lazyScreen(loadCreditProductScreens, 'CreditProductListScreen'),
});
